import { openBrowser } from 'common/js/browser-utils';
import CONFIG from 'common/js/config';
import { isIos } from '../../js/environment-utils';

export function openOptOut(options: FormatOptions) {
  const consentUrl = options.context.optoutUrl ?? CONFIG.OPT_OUT_SITE_URL;
  if (window.mraidOriginalOpen) {
    window.mraidOriginalOpen(consentUrl);
  } else {
    openBrowser(options, consentUrl, { forceDefault: true });
  }
}
